<template>
  <section class="product-quantity">
    <label v-if="!plain">Aantal:</label>

    <span v-if="editable" class="quantity-input-wrap" ref="inputWrap">
      <button class="qty-btn" @click="changeQuantity(-1)">−</button>
      <input
        class="qty-input"
        type="number"
        min="1"
        v-model.number="inputQuantity"
        @change="quantityInput(inputQuantity)"
        @blur="quantityCheck(inputQuantity)"
      />
      <button class="qty-btn" @click="changeQuantity(1)">+</button>
    </span>
    <span v-else>{{ quantity }}</span>
    <!-- Teleported so a scrolling/overflow-hidden parent (e.g. the file list)
         cannot clip the warning; positioned fixed next to the input -->
    <Teleport to="body">
      <div
        class="quantity-warning"
        v-if="minQuantityNotification"
        :style="warningStyle"
        @click.stop
      >
        <close-button
          class="close-button"
          @click="hideNotification"
        ></close-button>
        Let op, het minimale aantal voor dit product is
        {{ minQuantity }}.
      </div>
    </Teleport>
  </section>
</template>

<script>
export default {
  props: ['quantity', 'editable', 'minQuantity', 'plain'],
  data() {
    return {
      inputQuantity: this.quantity,
      minQuantityNotification: false,
      warningStyle: {}
    }
  },
  beforeUnmount() {
    this.hideNotification()
  },
  methods: {
    showNotification() {
      const rect = this.$refs.inputWrap?.getBoundingClientRect()
      if (!rect) return

      this.warningStyle = {
        left: rect.right + 15 + 'px',
        top: rect.top + rect.height / 2 + 'px'
      }
      this.minQuantityNotification = true
      // A fixed popup does not follow its input, so close it on scroll/resize
      window.addEventListener('scroll', this.hideNotification, true)
      window.addEventListener('resize', this.hideNotification)
    },
    hideNotification() {
      this.minQuantityNotification = false
      window.removeEventListener('scroll', this.hideNotification, true)
      window.removeEventListener('resize', this.hideNotification)
    },
    changeQuantity(delta) {
      const minQuantity = parseInt(this.minQuantity) || 1
      const val = Math.max(minQuantity, (this.inputQuantity || 1) + delta)
      this.inputQuantity = val
      this.$emit('setQuantity', val)
    },
    quantityInput(val) {
      let minQuantity = parseInt(this.minQuantity)
      let quantity = parseInt(val)

      if (quantity < minQuantity || isNaN(quantity) || quantity === 0) {
        return
      }

      this.$emit('setQuantity', quantity)
    },
    quantityCheck(val) {
      let minQuantity = parseInt(this.minQuantity)
      let quantity = parseInt(val)

      if (isNaN(quantity) || quantity === 0) {
        this.inputQuantity = 1
      } else if (quantity < minQuantity) {
        this.inputQuantity = minQuantity
        this.$emit('setQuantity', minQuantity)
        this.showNotification()
      }
    }
  },
  watch: {
    quantity: function (value, oldValue) {
      this.inputQuantity = value
    }
  }
}
</script>

<style lang="scss" scoped>
.product-quantity {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

label {
  line-height: 31px;
  font-weight: 600;
  //padding-right: 10px;
  margin-right: 0;
  float: none;
}

.quantity-input-wrap {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: white;
  border-radius: 50px;
  padding: 2px 4px;
  border: 1.5px solid var(--sub-color);
}

.qty-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: transparent;
  color: var(--sub-color);
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background: var(--sub-color);
    color: white;
  }
}

.qty-input {
  width: 36px;
  text-align: center;
  border: none;
  outline: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--sub-color);
  background: transparent;
  appearance: textfield;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    -webkit-appearance: none;
    margin: 0;
  }
}

.quantity-warning {
  position: fixed;
  transform: translateY(-50%);
  width: 230px;
  background: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0 10px;
  font-weight: 400;
  z-index: 1000;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -19px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid white;
    border-bottom: 10px solid transparent;
    border-top: 10px solid transparent;
  }
}

.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
